import React from 'react';
import './Contact.css';
import heroBanner from "../../assets/images/bn4.png";
const Contact = () => {
  return (
    <div className="contact-page">
      {/* Hero Parallax Section */}
      <div 
        className="contact-hero-section" 
        style={{ backgroundImage: `url(${heroBanner})` }}
      >
        <div className="contact-hero-content">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">Get in touch with the YourCare team</p>
        </div>
      </div>

      {/* Main Content Layout */}
      <div className="contact-main-container">
        <div className="contact-split-layout">
          
          {/* Left Column: Direct Details */}
          <div className="contact-details-col">
            <span className="contact-details-tag">CONTACT DETAILS</span>
            <h2 className="contact-heading">We'd Love to Hear From You</h2>
            <p className="contact-description">
              Have questions about our Ultimate 4-in-1 Skin Revitalizing Serum or need skincare advice? 
              Get in touch with us using the form or our direct details. Our scientific team is here to assist you.
            </p>

            <div className="contact-info-list">
              <div className="contact-info-item">
                <div className="info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                </div>
                <div>
                  <h3>Our Location</h3>
                  <p>Chemistry Research Laboratories, National University of Sciences and Technology (NUST), H-12 Islamabad, Pakistan</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                </div>
                <div>
                  <h3>Email Address</h3>
                  <p><a href="mailto:info@yourcare.pk">info@yourcare.pk</a></p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                </div>
                <div>
                  <h3>Phone Number</h3>
                  <p><a href="tel:03006005249">03006005249</a></p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="info-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <div>
                  <h3>Business Hours</h3>
                  <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>

            <div className="contact-socials-section">
              <h3>Follow Us</h3>
              <div className="contact-social-icons">
                <a href="https://www.instagram.com/yourcare.pk" target="_blank" rel="noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
                </a>
                <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                </a>
                <a href="https://whatsapp.com" target="_blank" rel="noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                </a>
              </div>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="contact-form-card">
            <h2 className="form-card-title">Send a Message</h2>
            <p className="form-card-subtitle">Fill out the form below and we will respond within 24 business hours.</p>

            <form onSubmit={(e) => e.preventDefault()} className="contact-form">
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" placeholder="Enter your full name" required />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input type="email" placeholder="Enter your email address" required />
              </div>

              <div className="form-group">
                <label>Subject</label>
                <input type="text" placeholder="What is your message about?" required />
              </div>

              <div className="form-group">
                <label>Your Message</label>
                <textarea rows="5" placeholder="Write your message here..." required></textarea>
              </div>

              <button type="submit" className="send-message-btn">Send Message</button>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;